import { useNavigate } from "react-router-dom"

import { MenuAdmin } from "@/components/admin/MenuAdmin"
import { MenuManager } from "@/components/manager/MenuManager"
import { Header } from "@/components/common/header/Header"
import { ModalPopUp } from "@/components/common/element/ModalPopUp"
import { CommonFileInput } from "@/components/common/element/fields/CommonFileInput"

import { useStore } from "@/stores/RootStoreContext"
import * as TrinityAPI from "@/requests/TrinityAPI"
import { BALANCE_ROUTE } from "@/routes"

import Dropdown, { Option } from "@/ui/components/Dropdown"

import { bankTypeOptions } from "./helper"

import { useState, type FC } from "react"
import type { IModalMessage } from "@/types/error/IModalMessage"
import type { SingleValue } from "react-select"
import type { IB64File } from "@/types/IB64File"

import style from "../style.module.scss"
import Button from "@/ui/components/Button"

export const InvoicesHistoryUpload: FC = () => {
  const { userStore } = useStore()
  const navigate = useNavigate()

  const [message, setMessage] = useState<IModalMessage | null>(null)
  const [isSending, setSending] = useState(false)
  const [bankType, setBankType] = useState("BRI")
  const [zip, setZip] = useState<IB64File | null>(null)

  const handleChangeBankType = (option: SingleValue<Option>) => {
    setBankType(String(option?.value))
  }

  const handleUploadZip = (file: IB64File) => {
    setZip(file)
  }

  const handleSubmit = (force = false) => {
    setSending(true)

    const payload = {
      bankType,
      force,
      zip: String(zip?.b64)
    }

    TrinityAPI.uploadInvoicesHistory(
      payload,
      response => {
        if (response.status === 200) {
          navigate(BALANCE_ROUTE)
        } else {
          setMessage({
            title: "Ошибка!",
            text: response.data.message || "Ошибка загрузки инвойса",
            _callback: () => "123"
          })
        }
      },
      () => setSending(false)
    )
  }

  return (
    <>
      <ModalPopUp
        message={message}
        actionButton={
          message?.text?.includes("уже имеются записи") ? (
            <Button variant="black" loading={isSending} onClick={() => handleSubmit(true)}>
              Загрузить принудительно
            </Button>
          ) : null
        }
        close={() => setMessage(null)}
      />
      {userStore.isManager ? <MenuManager active="balance" /> : <MenuAdmin active="balance" />}
      <main className="main-container" id="scrollable">
        <Header />
        <div className="container">
          <div className={style.mainContainer}>
            <h1 className="ui-heading">Загрузка выписок</h1>

            <div className={style.invoicesUploadInputs}>
              <Dropdown
                options={bankTypeOptions}
                value={{
                  value: bankType,
                  label: bankType
                }}
                label="Выберите тип банка"
                onChange={handleChangeBankType}
              />

              <div className={style.invoicesUploadFile}>
                <CommonFileInput
                  label="Архив"
                  placeholder="Загрузить"
                  name="zip"
                  errorModel={undefined}
                  _callback={handleUploadZip}
                  zipArchive
                  onlyZipArchive
                />

                {zip?.name && <div>Загруженный архив: {zip.name}</div>}
              </div>
            </div>

            <div className="flex-row-24">
              <Button disabled={!zip?.b64} loading={isSending} onClick={() => handleSubmit(false)}>
                Отправить
              </Button>
              <Button variant="grey" onClick={() => navigate(BALANCE_ROUTE)}>
                Назад
              </Button>
            </div>
          </div>
        </div>
      </main>
    </>
  )
}
